import { Email, NamedEmail } from "./types.generated";

export function namedEmail(name: string, email: Email): NamedEmail {
  return { name, email };
}
